import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SocketState {
  userSocketConnected: boolean;
  oddsSocketConnected: boolean;
  fancySocketConnected: boolean;
  eventSocketConnected: boolean;
  sportSocketConnected: boolean;
}

const initialState: SocketState = {
  userSocketConnected: false,
  oddsSocketConnected: false,
  fancySocketConnected: false,
  eventSocketConnected: false,
  sportSocketConnected: false,
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setUserSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.userSocketConnected = action.payload;
    },
    setOddsSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.oddsSocketConnected = action.payload;
    },
    setEventSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.eventSocketConnected = action.payload;
    },
    setSportSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.sportSocketConnected = action.payload;
    },
    setFancySocketConnected: (state, action: PayloadAction<boolean>) => {
      state.fancySocketConnected = action.payload;
    },
    resetSocketState: () => {
      return {
        userSocketConnected: false,
        oddsSocketConnected: false,
        eventSocketConnected: false,
        sportSocketConnected: false,
        fancySocketConnected: false,
      };
    },
  },
});

export const {
  setUserSocketConnected,
  setOddsSocketConnected,
  setEventSocketConnected,
  setSportSocketConnected,
  setFancySocketConnected,
  resetSocketState,
} = socketSlice.actions;

export default socketSlice.reducer;
